import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createPromptSuccess } from 'src/app/pages/add-prompt/state/add-prompt.actions';
import { savePromptDetailSuccess } from 'src/app/pages/prompt-details/state/prompt-detail.actions';
import { PromptOption } from 'src/app/pages/prompt-register/models/prompt-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { filterNamedOption } from '../../select/shared/filter-named-option';
import { promptOptionActions, resetPromptOptions } from './prompt-option.actions';

export const promptOptionFeatureKey = 'promptOptions';

export type PromptOptionState = EagerSelectState<PromptOption>;

const adapter = createEagerSelectAdapter<PromptOptionState, PromptOption>({
   featureKey: promptOptionFeatureKey,
   selectId: (prompt: PromptOption) => {
      return prompt.promptId;
   },
});

export const promptOptionSelectors = adapter.getSelectors(filterNamedOption);

const initialState = adapter.getInitialState();

export const promptOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   promptOptionActions.search,
   promptOptionActions.searchReset,
   promptOptionActions.loadFromApi,
   promptOptionActions.loadFromApiSuccess,
   promptOptionActions.loadFromApiFailure,
   null,
   on(createPromptSuccess, savePromptDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   }),
   on(resetPromptOptions, () => initialState)
);
